import CanadaPostAddressSearch from '@/services/CanadaPostAddressSearch'
import SlackNotification from '../services/SlackNotification'

const { VUE_APP_SLACK_NOTIFICATIONS_ENABLED } = process.env

export default {
  methods: {
    createSlackNotifictionObject (search, error, CDUID) {
      return {
        Error: error,
        Search_query: search,
        CDUID
      }
    },

    async searchAddress (searchString, params) {
      try {
        if (!searchString) return false
        const response = await CanadaPostAddressSearch.cpFind(searchString, params)

        if (!response || response?.data?.Items.length <= 0) {
          throw new Error(
            !params.LastId
              ? `Address search for ${searchString} returned no results`
              : `Subaddress search for ${params.LastId} failed or returned no results` // Tweak the message for subaddress search
          )
        }

        return response.data
      } catch (error) {
        console.error(error.message)
        if (!VUE_APP_SLACK_NOTIFICATIONS_ENABLED) return { error }
        const slackNotificationBody = this.createSlackNotifictionObject(searchString, error.message, params.CDUID)

        SlackNotification.send(process.env.VUE_APP_SLACK_CPOST_WEBHOOK_URL, slackNotificationBody)
        return { error }
      }
    },

    async retrieveAddress (addressId, params) {
      try {
        if (!addressId) return false
        const response = await CanadaPostAddressSearch.cpRetrieve(addressId)

        if (!response || response?.data?.Items.length <= 0) {
          throw new Error(
            `Address retrieve for ${addressId} returned no results`
          )
        }

        return response.data
      } catch (error) {
        console.error(error.message)

        if (!VUE_APP_SLACK_NOTIFICATIONS_ENABLED) return { error }
        const slackNotificationBody = this.createSlackNotifictionObject(addressId, error.message, params.CDUID)

        SlackNotification.send(process.env.VUE_APP_SLACK_CPOST_WEBHOOK_URL, slackNotificationBody)

        return { error }
      }
    }
  }
}
